var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"adobe-pdf-viewer-container"},[_c('div',{staticClass:"adobe-pdf-viewer",attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }